import { APICallV3Post } from 'reactApp/api/APICall';

export class R7ConvertAPICall extends APICallV3Post {
    _method = 'r7/convert';
}
